import {
  GetProjectByProjectIdProjectdashboardAndDashboardIdNewsApiResponse,
  openapi,
  PostProjectByProjectIdProjectdashboardAndDashboardIdNewsCommentReactionApiArg,
} from "../../../../../openapi";
import { IRootState } from "../../../../store";

const applyReactionToTarget = (
  target: { reactions?: TrpcReaction[] },
  userId: string,
  userName: string,
  emoji: string,
) => {
  const existingReactions = target.reactions ?? [];
  const existingReaction = existingReactions.find((reaction) => String(reaction.user._id) === String(userId));

  if (!emoji || existingReaction?.emoji === emoji) {
    target.reactions = existingReactions.filter(
      (reaction) => String(reaction.user._id) !== String(userId),
    );
    return;
  }

  if (existingReaction) {
    existingReaction.emoji = emoji;
    existingReaction.date = new Date().toISOString();
    return;
  }

  existingReactions.push({
    user: {
      _id: userId,
      name: userName,
    },
    date: new Date().toISOString(),
    emoji,
  });
  target.reactions = existingReactions;
};

const enhancedApi = openapi.enhanceEndpoints({
  endpoints: {
    getProjectByProjectIdProjectdashboardAndDashboardIdNews: {
      providesTags: ["TrpcNews"],
    },
    postProjectByProjectIdProjectdashboardNews: {
      invalidatesTags: ["TrpcNews"],
    },
    putProjectByProjectIdProjectdashboardNewsAndNewsItemId: {
      invalidatesTags: ["TrpcNews"],
    },
    postProjectByProjectIdProjectdashboardAndDashboardIdNewsCommentReaction: {
      async onQueryStarted(
        { projectId, dashboardId, body }: PostProjectByProjectIdProjectdashboardAndDashboardIdNewsCommentReactionApiArg,
        { dispatch, getState, queryFulfilled },
      ) {
        const state = getState() as IRootState;
        const user = state.globalReducer.user;

        if (!user?._id || !user.name) {
          return;
        }

        const patchResult = dispatch(
          openapi.util.updateQueryData(
            "getProjectByProjectIdProjectdashboardAndDashboardIdNews",
            { projectId, dashboardId },
            (draft) => {
              const item = draft.find((newsItem) => newsItem._id === body.commentId);
              if (!item) return;
              const target = body.replyId ? item.replies?.find((reply) => reply._id === body.replyId) : item;
              if (!target) return;
              applyReactionToTarget(target, user._id, user.name, body.emoji);
            },
          ),
        );

        try {
          const { data } = await queryFulfilled;

          dispatch(
            openapi.util.updateQueryData(
              "getProjectByProjectIdProjectdashboardAndDashboardIdNews",
              { projectId, dashboardId },
              (draft) => {
                const index = draft.findIndex((newsItem) => newsItem._id === data._id);
                if (index >= 0) {
                  draft[index] = data;
                }
              },
            ),
          );
        } catch {
          patchResult.undo();
        }
      },
    },
    postProjectByProjectIdProjectdashboardNewsSearch: {},
  },
});

export const newsTrpcApi = enhancedApi;

export type TrpcNewsItem = GetProjectByProjectIdProjectdashboardAndDashboardIdNewsApiResponse[number];

export type TrpcReaction = NonNullable<TrpcNewsItem["reactions"]>[number];
